import React from 'react';
import { tokens } from '../../styles/tokens';
import { useTheme } from '../../context/ThemeContext';
import { localizeItem } from '../../hooks/useLanguage';
import OptimizedImage from '../ui/OptimizedImage';
import { formatRestaurantPrice } from '../../utils/formatPrice';

const defaultT = { willBeLater: 'будет позже' };

export function ItemModal({ item, quantity, onClose, onAdd, onRemove, lang = 'ru', t = defaultT, currency = 'UZS' }) {
  const theme = useTheme();
  const { colors } = theme;
  const isUnavailable = !item?.is_available;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        backgroundColor: colors.overlay,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '480px',
          maxHeight: '85vh',
          backgroundColor: colors.bgCard,
          borderRadius: '24px 24px 0 0',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 -8px 32px rgba(0,0,0,0.4)',
          transition: 'background-color 0.3s',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Изображение */}
        <div style={{ position: 'relative', width: '100%', paddingTop: '56%', backgroundColor: colors.bgChip }}>
          {item?.image_url ? (
            <OptimizedImage
              src={item.image_url}
              alt={item.name_ru || item.name}
              style={{ position: 'absolute', inset: 0 }}
            />
          ) : (
            <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '64px' }}>
              🍽️
            </div>
          )}
          {isUnavailable && (
            <div style={{
              position: 'absolute', top: '12px', left: '12px',
              backgroundColor: colors.badgeBg,
              color: '#fff',
              fontSize: tokens.font.sizes.xs,
              fontWeight: tokens.font.weights.semibold,
              padding: '6px 12px',
              borderRadius: tokens.radius.full,
            }}>
              {t.willBeLater}
            </div>
          )}
          <button
            onClick={onClose}
            style={{
              position: 'absolute', top: '12px', right: '12px',
              width: '40px', height: '40px',
              borderRadius: '50%',
              backgroundColor: 'rgba(0,0,0,0.5)',
              border: 'none',
              color: '#fff',
              fontSize: '20px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            ×
          </button>
        </div>

        {/* Контент */}
        <div style={{ padding: '20px', overflowY: 'auto', flex: 1 }}>
          <h2 style={{ margin: '0 0 8px', fontSize: tokens.font.sizes.xl, fontWeight: '800', color: colors.text }}>
            {localizeItem(item, lang)}
          </h2>
          {(localizeItem(item, lang, 'description') || item?.description_ru) && (
            <p style={{ margin: '0 0 12px', fontSize: tokens.font.sizes.sm, color: colors.textSecondary, lineHeight: 1.4 }}>
              {localizeItem(item, lang, 'description') || item.description_ru}
            </p>
          )}
          {item?.weight && (
            <p style={{ margin: '0 0 16px', fontSize: tokens.font.sizes.sm, color: colors.textMuted }}>
              {item.weight}
            </p>
          )}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px' }}>
            <span style={{ fontSize: tokens.font.sizes.xl, fontWeight: '800', color: colors.text }}>
              {formatRestaurantPrice(item?.price ?? 0, currency)}
            </span>
            {isUnavailable ? (
              <div style={{ width: '36px', height: '36px', borderRadius: tokens.radius.md, backgroundColor: colors.bgChip }} />
            ) : quantity === 0 ? (
              <button
                onClick={() => onAdd(item)}
                style={{
                  width: '48px', height: '48px',
                  borderRadius: tokens.radius.md,
                  backgroundColor: colors.accent,
                  border: 'none',
                  color: '#fff',
                  fontSize: '24px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                +
              </button>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <button
                  onClick={() => onRemove(item.id)}
                  style={{
                    width: '40px', height: '40px',
                    borderRadius: tokens.radius.md,
                    backgroundColor: colors.bgChip,
                    border: 'none',
                    color: colors.text,
                    fontSize: '20px',
                    cursor: 'pointer',
                  }}
                >
                  −
                </button>
                <span style={{ fontSize: '18px', fontWeight: '600', minWidth: '24px', textAlign: 'center', color: colors.text }}>{quantity}</span>
                <button
                  onClick={() => onAdd(item)}
                  style={{
                    width: '40px', height: '40px',
                    borderRadius: tokens.radius.md,
                    backgroundColor: colors.accent,
                    border: 'none',
                    color: '#fff',
                    fontSize: '20px',
                    cursor: 'pointer',
                  }}
                >
                  +
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
